var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-in"},[_c('header',[_c('BrandHeader')],1),_c('CheckinMainFlow',{on:{"submit-form":_vm.doTheSubmitCheckin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }